import { fg } from '@atlaskit/platform-feature-flags/fg';

export const POPUP_SIZED_EXTERNAL_NAV_APP_IDS: ReadonlySet<string> = new Set([
	'11995cbf-629c-4d90-890c-7fdd0ed69c49',
	'094945a8-4d32-4f0f-8ab9-76245e467a82',
	'60add9ed-404d-42e8-8301-b659329d4ad0',
	'90b44d4a-14b7-4501-bd2c-5fe4a3fbc4e0',
]);

const POPUP_WIDTH = 480;
const POPUP_HEIGHT = 720;

function getCenteredPopupWindowFeatures(): string {
	const left = Math.max(0, Math.round((window.screen.availWidth - POPUP_WIDTH) / 2));
	const top = Math.max(0, Math.round((window.screen.availHeight - POPUP_HEIGHT) / 2));

	return `popup,width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top},noopener,noreferrer`;
}

export function navigate(
	url: string,
	type: 'same-tab' | 'new-tab',
	push?: (path: string) => void,
	appId?: string,
): void {
	switch (type) {
		case 'new-tab': {
			const usePopupSizedWindow =
				!!appId &&
				POPUP_SIZED_EXTERNAL_NAV_APP_IDS.has(appId) &&
				fg('store_forge_configure_renderer');

			window.open(
				url,
				'_blank',
				usePopupSizedWindow ? getCenteredPopupWindowFeatures() : 'noopener noreferrer',
			);
			break;
		}
		case 'same-tab':
			if (push) {
				push(url);
			} else {
				window.location.href = url;
			}
			break;
	}
}
